import { SiteMeta } from '@/components/site/SiteMeta';
import { StaticBody } from '@/pages/site/StaticBody';
import { ProdutoBody } from '@/pages/site/content/ProdutoBody';

export function ProdutoPage() {
  return (
    <>
      <SiteMeta
        title={'Produto - Operax'}
        description={'Atendimento, funil, indicadores, agenda, Pix e NFS-e no mesmo login. Veja o sistema Operax em telas reais.'}
        path={'/produto'}
      />
      <StaticBody html={ProdutoBody} />
    </>
  );
}
